import type React from 'react'

import { PopoverTrigger as OrigPopoverTrigger } from '@chakra-ui/react'

export const PopoverTrigger = OrigPopoverTrigger as React.FC<{
  children: React.ReactElement
}>
